import React, { useState } from 'react';
import { List } from 'lucide-react';
import { InlineLoadingSpinner } from '@spins-gcp/shared-components-react';
import { TooltipButton } from '../tooltip-button/tooltip-button';
import type { SavedView } from '../../interfaces/SavedView';
import styles from '../power-bi/power-bi-page.module.scss';

interface PowerBiListViewProps {
  views: SavedView[];
  viewsLoading: boolean;
  activeViewId: string | null;
  onApplyView: (view: SavedView) => Promise<void>;
}

export function PowerBiListView({
  views,
  viewsLoading,
  activeViewId,
  onApplyView,
}: PowerBiListViewProps) {
  const [showViews, setShowViews] = useState(false);

  const handleApplyView = async (view: SavedView) => {
    setShowViews(false);
    try {
      await onApplyView(view);
    } catch {
      // errors are surfaced by the parent (toolbar)
    }
  };

  return (
    <div className={styles['toolbar-btn-wrapper']}>
      <button
        className={`${styles['toolbar-btn']} ${
          showViews ? styles['active'] : ''
        }`}
        onClick={() => setShowViews((prev) => !prev)}
      >
        <List size={14} aria-hidden="true" />
        Saved Views
      </button>
      {showViews && (
        <div className={styles['views-dropdown']}>
          <div className={styles['views-header']}>Views</div>
          <div className={styles['views-list']}>
            {viewsLoading ? (
              <div className={styles['views-loading']}>
                <InlineLoadingSpinner />
              </div>
            ) : views.length === 0 ? (
              <span className={styles['views-empty']}>No saved views yet</span>
            ) : (
              views.map((view) => (
                <TooltipButton
                  key={view.viewId}
                  label={view.viewName}
                  isActive={activeViewId === view.viewId}
                  onClick={() => handleApplyView(view)}
                  className={styles['view-item']}
                  activeClassName={styles['active']}
                />
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
